(function () {
    'use strict';

    function initMegaMenuHover() {
        const dropdown = document.getElementById('mega-menu-hover-dropdown');
        const overlay = document.getElementById('mega-menu-hover-overlay');
        if (!dropdown) return;

        const productsCount = Number.parseInt(dropdown.dataset.productsCount) || 5;

        const imageEl = dropdown.querySelector('.mega-menu-hover__image');
        const imageWrapper = dropdown.querySelector('.mega-menu-hover__image-wrapper');
        const promoEl = dropdown.querySelector('.mega-menu-hover__promo');
        const ctaEl = dropdown.querySelector('.mega-menu-hover__cta');
        const titleEl = dropdown.querySelector('.mega-menu-hover__title');
        const descriptionArea = dropdown.querySelector('.mega-menu-hover__description-area');
        const descriptionEl = dropdown.querySelector('.mega-menu-hover__description');
        const submenuList = dropdown.querySelector('.mega-menu-hover__submenu-list');
        const submenuItems = dropdown.querySelector('.mega-menu-hover__submenu-items');
        const productsContainer = dropdown.querySelector('.mega-menu-hover__products-container');
        const productsGrid = dropdown.querySelector('.mega-menu-hover__products-grid');
        const breadcrumbCurrent = dropdown.querySelector('.mega-menu-hover__breadcrumb-current');
        const prevBtn = dropdown.querySelector('.mega-menu-hover__nav-arrow--prev');
        const nextBtn = dropdown.querySelector('.mega-menu-hover__nav-arrow--next');

        const menuItems = document.querySelectorAll('.header__inline-menu .mega-menu-hover-trigger');

        if (menuItems.length === 0) return;

        let currentCollection = null;
        let currentMenuHandle = null;
        let hideTimeout = null;
        let productsCache = {};
        let submenuCache = {};

        function updateDropdownPosition() {
            const header = document.querySelector('.section-header') || document.querySelector('header.header');
            const headerWrapper = document.querySelector('.header-wrapper');

            if (header) {
                const headerRect = header.getBoundingClientRect();
                const headerBottom = headerRect.bottom;
                dropdown.style.top = (headerBottom + 16) + 'px';
            } else if (headerWrapper) {
                const headerRect = headerWrapper.getBoundingClientRect();
                dropdown.style.top = (headerRect.bottom + 16) + 'px';
            }
        }

        async function fetchCollectionProducts(handle) {
            if (productsCache[handle]) {
                return productsCache[handle];
            }

            try {
                const fetchLimit = Math.min(productsCount + 3, 15);
                const response = await fetch(`/collections/${handle}/products.json?limit=${fetchLimit}`);
                if (!response.ok) throw new Error('Failed to fetch products');
                const data = await response.json();
                productsCache[handle] = data.products;
                return data.products;
            } catch (error) {
                console.warn('[MegaMenuHover] Could not fetch products:', error);
                return [];
            }
        }

        function getSubmenuLinks(menuItem) {
            const detailsEl = menuItem.closest('details.mega-menu');
            if (!detailsEl) return [];

            const submenuLinks = detailsEl.querySelectorAll('.mega-menu__list > li > a');
            const links = [];

            submenuLinks.forEach(link => {
                links.push({
                    title: link.textContent.trim(),
                    url: link.href,
                    handle: link.dataset.collectionHandle || ''
                });
            });

            return links;
        }

        function renderSubmenuLinks(links) {
            if (!submenuItems) return;

            submenuItems.innerHTML = '';

            links.forEach(link => {
                const li = document.createElement('li');
                li.className = 'mega-menu-hover__submenu-item';

                const a = document.createElement('a');
                a.href = link.url;
                a.className = 'mega-menu-hover__submenu-link';
                a.textContent = link.title;

                li.appendChild(a);
                submenuItems.appendChild(li);
            });
        }

        function renderProducts(products) {
            if (!productsGrid) return;

            productsGrid.innerHTML = '';

            products.slice(0, productsCount).forEach(product => {
                const hasEmBreveTag = product.tags && product.tags.includes('em-breve');
                const isOutOfStock = product.variants && product.variants.length > 0 &&
                    product.variants.every(v => !v.available);
                const isEmBreve = hasEmBreveTag || isOutOfStock;

                const productCard = document.createElement('a');
                productCard.href = `/products/${product.handle}`;
                productCard.className = 'mega-menu-hover__product';
                if (isEmBreve) productCard.dataset.emBreve = 'true';

                const imageUrl = product.images && product.images[0]
                    ? product.images[0].src
                    : '';

                const isBrinde = ['the-icon-bag', 'the-wild-bag', 'the-pop-bag'].includes(product.handle);

                let priceHtml = '';
                if (!isBrinde && product.variants && product.variants[0]) {
                    const variantPrice = Number.parseFloat(product.variants[0].price);
                    const compareAtPrice = Number.parseFloat(product.variants[0].compare_at_price);
                    const formattedPrice = variantPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

                    if (compareAtPrice && compareAtPrice > variantPrice) {
                        const formattedCompare = compareAtPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                        const discount = Math.round(((compareAtPrice - variantPrice) / compareAtPrice) * 100);
                        priceHtml = `
                            <span class="mega-menu-hover__product-price">${formattedPrice}</span>
                            <span class="mega-menu-hover__product-price mega-menu-hover__product-price--compare">${formattedCompare}</span>
                            ${discount > 0 ? `<span class="mega-menu-hover__product-discount">-${discount}%</span>` : ''}
                        `;
                    } else {
                        priceHtml = `<span class="mega-menu-hover__product-price">${formattedPrice}</span>`;
                    }
                }

                productCard.innerHTML = `
                    <div class="mega-menu-hover__product-image-wrapper">
                        ${isEmBreve ? '<span class="badge badge--em-breve" style="position:absolute;top:8px;left:8px;z-index:2;">Em Breve</span>' : ''}
                        <img
                            class="mega-menu-hover__product-image"
                            src="${imageUrl}"
                            alt="${product.title}"
                            loading="lazy"
                        >
                    </div>
                    <div class="mega-menu-hover__product-info">
                        <span class="mega-menu-hover__product-title">${(window.theoricNomes && window.theoricNomes[product.handle]) || product.title}</span>
                        ${priceHtml}
                    </div>
                `;

                productsGrid.appendChild(productCard);
            });

            requestAnimationFrame(() => {
                updateArrowStates();
                setTimeout(() => updateArrowStates(), 100);
            });
        }

        function renderSkeleton(grid) {
            if (!grid) return;
            grid.innerHTML = '';

            for (let i = 0; i < productsCount; i++) {
                const skeletonItem = document.createElement('div');
                skeletonItem.className = 'mega-menu-hover__product';
                skeletonItem.innerHTML = `
                    <div class="mega-menu-hover__product-image-wrapper skeleton" style="border-radius: 0;"></div>
                    <div class="mega-menu-hover__product-info">
                        <div class="skeleton" style="width: 80%; height: 10px; margin-bottom: 4px;"></div>
                        <div class="skeleton" style="width: 40%; height: 10px;"></div>
                    </div>
                `;
                grid.appendChild(skeletonItem);
            }

            requestAnimationFrame(() => {
                updateArrowStates();
            });
        }

        function updateArrowStates() {
            if (!productsContainer || !prevBtn || !nextBtn) return;

            const scrollWidth = productsContainer.scrollWidth;
            const clientWidth = productsContainer.clientWidth;
            const scrollLeft = productsContainer.scrollLeft;
            const maxScroll = scrollWidth - clientWidth;

            if (maxScroll <= 1) {
                prevBtn.disabled = true;
                nextBtn.disabled = true;
                prevBtn.style.opacity = '0.5';
                nextBtn.style.opacity = '0.5';
                prevBtn.style.pointerEvents = 'none';
                nextBtn.style.pointerEvents = 'none';
            } else {
                prevBtn.disabled = false;
                nextBtn.disabled = false;
                prevBtn.style.opacity = '1';
                nextBtn.style.opacity = '1';
                prevBtn.style.pointerEvents = 'auto';
                nextBtn.style.pointerEvents = 'auto';
            }

            const parent = productsContainer.closest('.mega-menu-hover__products');
            if (parent) {
                if (scrollLeft > 10) {
                    parent.classList.add('has-scroll-left');
                } else {
                    parent.classList.remove('has-scroll-left');
                }
                if (scrollLeft < maxScroll - 10) {
                    parent.classList.add('has-scroll-right');
                } else {
                    parent.classList.remove('has-scroll-right');
                }
            }
        }

        function scrollProducts(direction) {
            if (!productsContainer) return;

            const itemWidth = 174;
            const scrollAmount = itemWidth;
            const maxScroll = productsContainer.scrollWidth - productsContainer.clientWidth;
            const currentScroll = productsContainer.scrollLeft;

            if (direction === 1) {
                if (currentScroll >= maxScroll - 10) {
                    productsContainer.scrollTo({
                        left: 0,
                        behavior: 'smooth'
                    });
                } else {
                    productsContainer.scrollBy({
                        left: scrollAmount,
                        behavior: 'smooth'
                    });
                }
            } else {
                if (currentScroll <= 10) {
                    productsContainer.scrollTo({
                        left: maxScroll,
                        behavior: 'smooth'
                    });
                } else {
                    productsContainer.scrollBy({
                        left: -scrollAmount,
                        behavior: 'smooth'
                    });
                }
            }

            setTimeout(updateArrowStates, 350);
        }

        async function showDropdown(item) {
            const handle = item.dataset.collectionHandle;
            const title = item.dataset.collectionTitle;
            const description = item.dataset.collectionDescription;
            const imageUrl = item.dataset.collectionImage;

            if (!handle) return;

            const isNewCollection = handle !== currentCollection;
            currentCollection = handle;
            currentMenuHandle = item.id || item.dataset.collectionHandle;

            menuItems.forEach(mi => mi.classList.remove('mega-hover-active'));
            item.classList.add('mega-hover-active');

            if (breadcrumbCurrent) {
                breadcrumbCurrent.textContent = title || '';
            }

            if (titleEl) {
                titleEl.textContent = title || '';
            }

            const submenuLinks = getSubmenuLinks(item);

            if (submenuLinks.length > 0 && submenuList && descriptionArea) {
                descriptionArea.style.display = 'none';
                submenuList.style.display = 'block';
                renderSubmenuLinks(submenuLinks);
            } else if (descriptionArea && submenuList) {
                descriptionArea.style.display = 'block';
                submenuList.style.display = 'none';
                if (descriptionEl) {
                    descriptionEl.textContent = description || '';
                }
            }

            const isPromo = item.dataset.collectionPromo === 'black';
            if (imageWrapper) {
                imageWrapper.classList.toggle('is-promo-black', isPromo);
            }
            if (promoEl) {
                promoEl.hidden = !isPromo;
            }

            if (ctaEl) {
                ctaEl.href = '/collections/' + handle;
                ctaEl.hidden = false;
            }

            if (imageEl && imageUrl) {
                imageEl.classList.remove('loaded');
                imageEl.src = imageUrl;
                imageEl.alt = title || '';

                imageEl.onload = () => {
                    imageEl.classList.add('loaded');
                };
            }

            if (isNewCollection && productsGrid) {
                renderSkeleton(productsGrid);
                const products = await fetchCollectionProducts(handle);
                if (currentCollection === handle) {
                    renderProducts(products);
                    if (productsContainer) {
                        productsContainer.scrollLeft = 0;
                    }
                }
            }

            updateDropdownPosition();

            if (overlay) {
                overlay.classList.add('is-active');
            }

            dropdown.style.display = 'block';
            dropdown.classList.add('is-active');

            requestAnimationFrame(() => {
                updateArrowStates();
                setTimeout(() => updateArrowStates(), 350);
            });
        }

        function hideDropdown() {
            currentCollection = null;
            currentMenuHandle = null;
            dropdown.classList.remove('is-active');
            menuItems.forEach(mi => mi.classList.remove('mega-hover-active'));

            if (overlay) {
                overlay.classList.remove('is-active');
            }

            setTimeout(() => {
                if (!dropdown.classList.contains('is-active')) {
                    dropdown.style.display = 'none';
                }
            }, 500);
        }

        function handleMouseEnter(event) {
            clearTimeout(hideTimeout);
            showDropdown(event.currentTarget);
        }

        function handleMouseLeave() {
            hideTimeout = setTimeout(() => {
                hideDropdown();
            }, 200);
        }

        menuItems.forEach(item => {
            item.addEventListener('mouseenter', handleMouseEnter);
            item.addEventListener('mouseleave', handleMouseLeave);
        });

        dropdown.addEventListener('mouseenter', () => {
            clearTimeout(hideTimeout);
        });

        dropdown.addEventListener('mouseleave', () => {
            hideTimeout = setTimeout(() => {
                hideDropdown();
            }, 150);
        });

        if (prevBtn) {
            prevBtn.addEventListener('click', (e) => {
                e.preventDefault();
                scrollProducts(-1);
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', (e) => {
                e.preventDefault();
                scrollProducts(1);
            });
        }

        if (productsContainer) {
            productsContainer.addEventListener('scroll', () => {
                updateArrowStates();
            }, { passive: true });
        }

        if (overlay) {
            overlay.addEventListener('click', () => {
                hideDropdown();
            });
        }

        document.addEventListener('click', (e) => {
            if (!dropdown.contains(e.target) &&
                !e.target.closest('.mega-menu-hover-trigger') &&
                !e.target.closest('.mega-menu-hover-overlay')) {
                hideDropdown();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                hideDropdown();
            }
        });

        window.addEventListener('scroll', () => {
            if (dropdown.classList.contains('is-active')) {
                hideDropdown();
            }
        }, { passive: true });

        window.addEventListener('resize', () => {
            if (dropdown.classList.contains('is-active')) {
                updateDropdownPosition();
                updateArrowStates();
            }
        }, { passive: true });

        dropdown.addEventListener('transitionend', (e) => {
            if (e.target === dropdown && dropdown.classList.contains('is-active')) {
                updateArrowStates();
            }
        });

        if (dropdown.classList.contains('is-active')) {
            updateArrowStates();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMegaMenuHover);
    } else {
        initMegaMenuHover();
    }
})();
